'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tooltip/dist/decorators/isCapture.js
// module id = ./node_modules/react-tooltip/dist/decorators/isCapture.js
// module chunks = vendor